import React from "react";
import { Field, useFormikContext } from "formik";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import Button from "@mui/material/Button";
import { pink } from "@mui/material/colors";
import {
  calculateSum,
  calculateInputSum,
} from "../../CommonFuntion/TotalQuantity";
import {
  clampMinIfCondition,
  isExceedMaxIfCondition,
  applyRoundIfCondition,
  applyPercentageIncreaseIfCondition,
} from "../../CommonFuntion/ConditionalValidation";

const TableQuantityInputComponent = ({
  element,
  tableName,
  tdkeys,
  name,
  showInputQuantity,
  showWastageOption,
  error,
  errorBorder,
  id,
  rowkeys,
  setTotalSum,
  setTotalInputSum,
  props,
}) => {
  const { values, setFieldValue } = useFormikContext();

  const handleInputChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (isNaN(value)) return;

    const { minValue, roundOffQty } = element.validation;
    let roundedValue = applyRoundIfCondition(value, roundOffQty, element.validation);
    roundedValue = clampMinIfCondition(roundedValue, minValue, element.validation);
    roundedValue = roundedValue.toString();

    values[tableName][tdkeys][`INQ${element.tagName}`] = e.target.value;
    values[tableName][tdkeys][name] = roundedValue;

    setFieldValue(`${tableName}[${tdkeys}].${name}`, roundedValue);
    setFieldValue(
      `${tableName}[${tdkeys}].INQ${element.tagName}`,
      e.target.value
    );

    setTotalSum(calculateSum(props, values[tableName]));
    setTotalInputSum(calculateInputSum(props, values[tableName]));
  };

  const handleApplyClick = () => {
    const wastage = parseInt(
      values[tableName][0]?.wastagePercent ?? element.validation.wastagePercent,
      10
    );
    if (isNaN(wastage)) return;

    values[tableName].forEach((row, i) => {
      const inputQty = values[tableName][i][name];
      if (inputQty !== "") {
        const base = parseInt(inputQty, 10);
        if (!isNaN(base)) {
          const updated = applyPercentageIncreaseIfCondition(base, wastage, element.validation);
          const totalQty = String(updated);
          values[tableName][i][name] = totalQty;
          setFieldValue(`${tableName}[${i}].${name}`, totalQty);
        }
      }
    });

    setTotalSum(calculateSum(props, values[tableName]));
    setTotalInputSum(calculateInputSum(props, values[tableName]));
  };

  // Render input field for quantity
  if (element?.prefix === "QTY" && !showInputQuantity && !showWastageOption) {
    const inputValue = !isNaN(parseInt(values?.[tableName]?.[tdkeys]?.[name]))
      ? values?.[tableName]?.[tdkeys]?.[name]
      : "";

    const title = [
      element.validation?.pictureMask
        ? `Picture Mask:${element.validation.pictureMask}`
        : "",
      element.validation?.mandatory ? "Mandatory" : "",
    ]
      .filter(Boolean)
      .join("\n");

    return (
      <div className="wrapper">
        <div>
          <Field
            title={title}
            max={element.validation?.maxValue}
            type="number"
            className={`tableInput ${errorBorder}`}
            id={id + tdkeys + 1}
            rowkeys={tdkeys}
            tdkeys={rowkeys}
            name={`${tableName}[${tdkeys}].${name}`}
            value={inputValue}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) e.preventDefault();
              const nextStr = (e.target.value ?? "") + e.key;
              const currentValue = parseInt(nextStr, 10);
              if (isNaN(currentValue)) return;

              const maxValue = element.validation?.maxValue;
              if (isExceedMaxIfCondition(currentValue, maxValue, element.validation)) {
                e.preventDefault();
              }
            }}
            onBlur={handleInputChange}
            data-testid="TableQuantityInputComponent"
          />
          {error?.[name] && (
            <span className="icon">
              <Tooltip title={error?.[name]}>
                <WarningIcon sx={{ color: pink[500] }} />
              </Tooltip>
            </span>
          )}
        </div>
      </div>
    );
  }

  // Render label for input quantity
  if (element?.prefix === "QTY" && showInputQuantity) {
    const inputQuantity =
      values?.[tableName]?.[tdkeys]?.[`INQ${element?.tagName}`];
    return (
      <div className="wrapper">
        <div>
          <label
            name={`${tableName}[${tdkeys}].INQ${element?.tagName}`}
            rowkeys={`INQ${tdkeys}`}
            tdkeys={`INQ${rowkeys}`}
          >
            {inputQuantity}
          </label>
        </div>
      </div>
    );
  }

  // Render wastage option input and apply button
  if (element?.prefix === "QTY" && showWastageOption) {
    return (
      <div className="wrapper">
        <div>
          {tdkeys === 0 && (
            <>
              <input
                type="text"
                className="wastage-input"
                value={
                  values?.[tableName]?.[0]?.wastagePercent ||
                  element.validation.wastagePercent
                }
                //defaultValue={element.validation.wastagePercent}
                onChange={(e) =>
                  setFieldValue(
                    `${tableName}[${tdkeys}].wastagePercent`,
                    e.target.value
                  )
                }
              />{" "}
              %
              <Button
                className="clearbtn"
                variant="contained"
                onClick={handleApplyClick}
                component="label"
              >
                Apply
              </Button>
            </>
          )}
        </div>
      </div>
    );
  }

  return null;
};

export default TableQuantityInputComponent;
